export const managePresignedUrlsSent = ({ response }) => {
  if (response?.action_code === "presigned_urls_sent") {
    const presignedUrlsDataResponse = response?.payload?.presigned_url_list;

    const sanitizedList = [];
    if (presignedUrlsDataResponse && Array.isArray(presignedUrlsDataResponse)) {
      presignedUrlsDataResponse.forEach((item) => {
        const { image_name: imageName, presigned_url: presignedUrl } = item;
        sanitizedList.push({ imageName, presignedUrl });
      });
      return sanitizedList;
    } else {
      return [];
    }
  }
};
